function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import RadioTileGroup from './radio-tile-group';
import React from 'react';
import UploadFile from './upload-file';

var MerchantLogo = /*#__PURE__*/function (_React$Component) {
  _inherits(MerchantLogo, _React$Component);

  var _super = _createSuper(MerchantLogo);

  function MerchantLogo(props) {
    var _this;

    _classCallCheck(this, MerchantLogo);

    _this = _super.call(this, props);

    _this.merchantLogoUpload = function (reader, inputFile) {
      var logos = [_this.props.details.merchantLogo.details];
      var fileUrl = reader.result;
      logos[0].url = fileUrl;

      _this.props.onStyleChange('merchantLogoFile', inputFile);

      _this.props.onStyleChange('merchantLogoFileUrl', fileUrl);

      _this.props.onUpdateWpfUiStateSupportedFeatureValue('show_merchant_logo', logos);
    };

    _this.merchantLogoTiles = [{
      identifier: 'merchant-logo-on',
      label: I18n.t('javascript.common.on'),
      value: 'true'
    }, {
      identifier: 'merchant-logo-off',
      label: I18n.t('javascript.common.off'),
      value: 'false'
    }];
    return _this;
  }

  _createClass(MerchantLogo, [{
    key: "defaultLogoSize",
    get: function get() {
      var _this$props$details = this.props.details,
          size = _this$props$details.size,
          sizes = _this$props$details.sizes;
      return sizes.find(function (item) {
        return item.value === size;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("section", {
        className: "style-section"
      }, React.createElement("h6", null, I18n.t('javascript.v2.wpf_custom_theme.styling.merchant_logo')), React.createElement("ul", {
        className: "style-section-list"
      }, React.createElement("li", {
        className: "style-section-row"
      }, React.createElement("span", null, I18n.t('javascript.v2.wpf_custom_theme.styling.show_merchant_logo')), React.createElement(RadioTileGroup, {
        name: "wpf_custom_theme_v2[supported_features][show_merchant_logo]",
        onChange: function onChange(value) {
          _this2.props.onUpdateSupportedFeature('show_merchant_logo', value);
        },
        selectedTile: this.props.supportedFeatures.includes('show_merchant_logo').toString(),
        tiles: this.merchantLogoTiles
      })), React.createElement("li", {
        className: "style-section-row"
      }, React.createElement("span", null, I18n.t('javascript.v2.wpf_custom_theme.styling.merchant_logo_upload')), React.createElement(UploadFile, {
        availableFileFormats: this.props.details.merchantLogo.contentTypeAllowlist,
        id: "merchant-logo",
        onFileUpload: this.merchantLogoUpload,
        tooltip: I18n.t('javascript.v2.wpf_custom_theme.styling.merchant_logo_tooltip', {
          allowed_extensions: '.svg'
        })
      })), React.createElement("li", {
        className: "style-section-row"
      }, React.createElement("span", null, I18n.t('javascript.v2.wpf_custom_theme.styling.merchant_logo_size')), React.createElement(RadioTileGroup, {
        name: "wpf_custom_theme_v2[logo_size]",
        onChange: function onChange(value) {
          return _this2.props.onStyleChange('logo_size', value);
        },
        tiles: this.props.details.sizes,
        selectedTile: this.defaultLogoSize.value
      }))));
    }
  }]);

  return MerchantLogo;
}(React.Component);

export default MerchantLogo;